(() => {
  // src/js/product.js
  document.addEventListener("DOMContentLoaded", () => {
    function updateAccordionMetafields(variantId) {
      if (!variantId) {
        return;
      }
      ;
      const activeDataStore = document.querySelector(`.variant-information[data-variant-id="${variantId}"]`);
      if (!activeDataStore) {
        return;
      }
      ;
      const getContent = (selector) => activeDataStore.querySelector(selector)?.innerHTML || "";
      const sections = [
        {
          container: document.querySelector(".product-title"),
          content: getContent(".variant-information__title"),
          isAccordion: false
        },
        {
          container: document.querySelector(".product-description"),
          content: getContent(".variant-information__description"),
          isAccordion: false
        },
        {
          container: document.querySelector(".strengths_content"),
          content: getContent(".variant-information__bullet-point"),
          isAccordion: true
        },
        {
          container: document.querySelector(".technical_features_content"),
          content: getContent(".variant-information__technical-features"),
          isAccordion: true
        },
        {
          container: document.querySelector(".documents_content"),
          content: getContent(".variant-information__documents"),
          isAccordion: true
        },
        {
          container: document.querySelector(".product-info__block-item[data-block-type='custom-notes']"),
          content: getContent(".variant-information__custom-notes"),
          isAccordion: false
        }
      ];
      sections.forEach(({ container, content, isAccordion }) => {
        if (!container) {
          return;
        }
        ;
        const target = isAccordion ? container.closest(".accordion") : container;
        target.hidden = !content;
        if (content) {
          container.innerHTML = content;
        }
      });
    }
    document.addEventListener("variant:change", (event) => {
      const variantIdSelected = event.detail.variant.id;
      updateAccordionMetafields(variantIdSelected);
    });
  });
})();
